import { useEffect, useMemo, useState } from "react";

export function useActiveSection<T extends string>(
  ids: readonly T[],
  options?: IntersectionObserverInit
) {
  const [activeId, setActiveId] = useState<T>(ids[0]);
  const idSet = useMemo(() => new Set(ids), [ids]);

  useEffect(() => {
    const elements = ids
      .map((id) => document.getElementById(id))
      .filter((el): el is HTMLElement => Boolean(el));

    if (elements.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((e) => e.isIntersecting)
        .sort((a, b) => (b.intersectionRatio ?? 0) - (a.intersectionRatio ?? 0))[0];

      const id = visible?.target?.id as T | undefined;
      if (id && idSet.has(id)) setActiveId(id);
    }, options);

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [ids, idSet, options?.root, options?.rootMargin, options?.threshold]);

  return activeId;
}

